import { ArrowLeftIcon } from "@/icons/ArrowLeft";
import { FC, ReactNode } from "react";
import { Link, useLocation } from "react-router";

export interface ILayoutHeaderProps {
  children?: ReactNode;
}

const LayoutHeader: FC<ILayoutHeaderProps> = ({ children }) => {
  const location = useLocation();
  const locationIsAppRoot = location.pathname === "/";

  return (
    <div className="w-full h-25 flex items-center gap-4 bg-white px-4 py-4 shadow-sm">
      {!locationIsAppRoot && (
        <Link to="/" className="icon-btn">
          <ArrowLeftIcon />
        </Link>
      )}

      {children}
    </div>
  );
};

export default LayoutHeader;
